import React from 'react';
import Header from '../JobPage/Header';
import SearchBar from './SearchBar';
import JobFilters from './JobFilters';
import JobList from './JobList';
import Footer from './Footer';
import { Container } from '../Components/ui/container';
import { Inline } from '../Components/ui/layout';

const JobsPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <main>
        <Header />
        <SearchBar />
        <Container>
          <Inline spacing="lg" align="start" className="py-lg flex-col md:flex-row">
            <JobFilters />
            <JobList />
          </Inline>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default JobsPage;